import React from 'react';

export default function ManualDistributionPanel({actions, children}) {
    return (
        <div className="manual_distribution__panel">
            <div className="manual_distribution__body">{children}</div>

            <div className="manual_distribution__actions">{actions}</div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./components/manual_distribution_modal/manual_distribution_panel.js